<app-admin-panel-user-organization-data-section
  sectionTitle="Dane identyfikacyjne"
  [fields]="fields()"
></app-admin-panel-user-organization-data-section>
